// eslint-disable-next-line no-restricted-imports
import { z } from 'zod'
import { i18n as i18nType } from 'i18next'

import { Language } from '@/entities/common/Locale'

import { zodLocales } from './zod'
import { makeZodI18nMap } from './zod-i18n'

z.config({
    localeError: makeZodI18nMap({ ns: ['zod', 'custom'] }),
})

const cachedZodI18nMap: Record<string, z.core.$ZodErrorMap> = {}

export const changeI18nErrorMap = (i18n: i18nType) => {
    setZodLocale(i18n)

    z.config({
        localeError: makeZodI18nMap(i18n),
    })
}

export const getI18nErrorMap = (i18n: i18nType): z.core.$ZodErrorMap => {
    setZodLocale(i18n)

    if (!cachedZodI18nMap[i18n.language]) {
        cachedZodI18nMap[i18n.language] = makeZodI18nMap(i18n)
    }

    return cachedZodI18nMap[i18n.language]
}

const setZodLocale = (i18n: i18nType) => {
    const language = i18n.language?.split('-')[0]
    if (Object.keys(zodLocales).includes(language)) {
        // TypeScript fix: ensure language is a valid key of zodLocales
        const lang = language as Language
        const defaultZodError = zodLocales[lang]?.().localeError

        if (defaultZodError) {
            z.config({
                localeError: defaultZodError,
            })
        }
    }
}
